export const projectRoot = '/home/runner/work/NG-INAPP-DEVTOOL/NG-INAPP-DEVTOOL';
